import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { NgModule, ModuleWithProviders, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AgGridModule } from 'ag-grid-angular';
import { BasicCellHeaderComponent } from './search/results/result-data-table/renderers/basic-cell-header/basic-cell-header.component';
import { BasicCellRendererComponent } from './search/results/result-data-table/renderers/basic-cell-renderer/basic-cell-renderer.component';
import { PinnedCellRendererComponent } from './search/results/result-data-table/renderers/pinned-cell-renderer/pinned-cell-renderer.component';
import { BasicCellEditorComponent } from './search/results/result-data-table/editors/basic-cell-editor/basic-cell-editor.component';
import { ResultDataTableComponent } from './search/results/result-data-table/result-data-table.component';
import { ResultDataMapperComponent } from './search/results/result-data-mapper/result-data-mapper.component';
import { SearchFilterComponent } from './search/filter/search-filter.component';
import { SearchFilterClauseComponent } from './search/filter/search-filter-clause/search-filter-clause.component';
import { SearchFilterConditionComponent } from './search/filter/search-filter-condition/search-filter-condition.component';
import { TitleCasePipe } from '../shared/pipes/title-case.pipe';
import { SCECoreModule } from 'sce-core';
import { LookupPopupComponent } from './lookup/popup/lookup-popup.component';
import { ButtonPanelComponent } from './button/button-panel.component';
import { ButtonFactoryService } from './button/button-factory.service';
import { TemplateRefDirective } from './directives/template-ref.directive';
import { TrackScrollDirective } from './directives/track-scrollevent.directive';
import { DataTableEditorService } from './search/results/data-table-editor.service';
import { ResetScrollDirective } from '../shared/directives/reset-scroll.directive';
import { DropdownComponent } from './components/dropdown/dropdown.component';
import { PaginatorComponent } from './components/paginator/paginator.component';
import { FocusDirective } from '../shared/directives/focus.directive';
import { CalendarModule, DataTableModule, DialogModule, TooltipModule, TabViewModule, DropdownModule, SliderModule, InputMaskModule } from 'primeng/primeng';
import { DocumentUtilService } from './services/document-util.service';
import { SearchableEntitySearchComponent } from './components/searchable-entity/search-page/search-page.component';
import { SearchableEntityDetailsComponent } from './components/searchable-entity/details-page/details-page.component';
import { PopulatePopupComponent } from './lookup/populate-item-detail/populate-popup.component';
import { ViewbalanceLookupComponent } from './lookup/viewbalance-lookup/viewbalance-lookup.component';
import { AccordionComponent } from './components/accordion/accordion.component';
import { ViewbalanceService } from './lookup/viewbalance-lookup/viewbalance-lookup.service';
import { PrintLookupComponent } from './lookup/print-lookup/print-lookup.component';
import { ButtonPanelHeaderComponent } from './button/button-panel-header/button-panel-header.component';
import { ReceiptDataService } from './services/receipt/receipt-data.service';
import { ReceiptDataEditorService } from './services/receipt/receipt-data-editor.service';
import { ManageSavedSearchComponent } from './search/filter/manage-saved-search/manage-saved-search.component';
import { PrinterService } from './services/printer.service';
import { TooltipComponent } from './components/tooltip/tooltip.component';
import { AccordionLayoutComponent } from './components/platform/lf-accordion/lf-accordion.component';
import { LfTabbedpaneComponent, LfTabbedpanesComponent } from './components/platform/lf-tabbedpane/lf-tabbedpane.component';
import { OverflowTooltipDirective } from './directives/overflow-tooltip.directive';
import { RouterModule } from '@angular/router';
 import { PrinterSetupService } from 'sce-home';
import { ValidatorService } from './services/validator.service';
import { ClickOutsideDirective } from './directives/click-outside.directive';
import { ScrollBottomDirective } from './directives/scroll-bottom.directive';
import { SharedServiceRegistry } from './shared-service-registry';
import { SavedSearchService } from './search/saved-search.service';
import { TableCustomizerComponent } from './search/results/result-data-table/table-customizer/table-customizer.component';
// tslint:disable-next-line:max-line-length
import { ViewLottablesLookupComponent } from './lookup/viewlottables-lookup/viewlottables-lookup.component';
import { ViewLottableService } from './lookup/viewlottables-lookup/viewlottables-lookup.service';
import { ImportComponent } from './components/import/import.component';
import { ImportLookupComponent } from './lookup/import-lookup/import-lookup-popup.component';
import { FileImportService } from './services/file-import.service';
import { DefaultAccordionLayoutComponent } from './components/layout/default-accordion-layout/default-accordion-layout.component';
import { MultitabSearchableEntitySearchComponent } from './components/searchable-entity/multitab-search-page/multitab-search-page.component';
import { InvLookupComponent } from '../features/control/inventory-balance/popup/invLookup-popup.component';
import { InventoryBalanceSearchableEntitySearchComponent } from '../features/control/inventory-balance/search-page/inv-balance-search-page.component';
import { SearchableEntityDynamicDetailsComponent } from './components/searchable-entity/dynamic-details-page/dynamic-details-page.component';
import { ColumnLayoutPrimaryWidgetComponent } from './components/widget/column-layout-primary-widget/column-layout-primary-widget.component';
import { ColumnLayoutSecWidgetComponent } from './components/widget/column-layout-sec-widget/column-layout-sec-widget.component';
import { DynamicWidgetHolderComponent } from './components/widget/dynamic-widget-holder/dynamic-widget-holder.component';
import { AbstractFormWidgetComponent } from './components/widget/abstract-form-widget/abstract-form-widget.component';
// tslint:disable-next-line:max-line-length
import { WORPacketCellRendererComponent } from '../features/inventory/work-order-management/configuration/work-order-routing/aggrid-custom-cell/filename-cell-renderer.component';
import { WOPacketCellRendererComponent } from '../features/inventory/work-order-management/work-order-execution/work-orders/aggrid-custom-cell/filename-cell-renderer.component';
import { MultiTabbedDetailTableComponent } from './components/widget/multi-tabbed-detail-table/multi-tabbed-detail-table';
import { ShowEmptyLocationLookupComponent } from '../features/inventory/abc-control/abc-moves/popup/show-empty-location-lookup-popup.component';
import { SearchService } from './search/search.service';
import { LocalPagedSearchService } from './search/localpaged-search.service';
import { SearchParams } from './search/models/search-params.model';
import { SearchStatus } from './search/models/search-status.model';
// tslint:disable-next-line:max-line-length
import { WorkOrdersPrimaryAccordianComponent } from '../features/inventory/work-order-management/work-order-execution/work-orders/work-orders-primary-accordian/work-orders-primary-accordian.component';
import { SimpleWidgetLayoutComponent } from './components/layout/simple-widget-layout/simple-widget-layout.component';
import { CrossFunctionalityNavigationService } from './services/cross-functionality-navigation.service';
import { StorerSODefaultWidgetComponent } from './components/widget/storer-so-default-widget/storer-so-default-widget';
import { LocalPagedDataManager } from './search/local-paged-data-manager.service';
import { StorerAdditionalInfoWidgetComponent } from './components/widget/additional-info-widget/additional-info-widget';
import { DirectMovesAccordianComponent } from '../features/inventory/direct-moves/direct-moves-accordian/direct-moves-accordian.component';
import { SearchableEntityStaticFormComponent } from './components/searchable-entity/static-form-page/static-form-page.component';
import { GridDatepickerComponent } from './components/datepicker-grid/datepicker-grid.component';
import { LookupInputComponent } from './components/lookup-input/lookup-input.component';
import { LookupFilterInputComponent } from './components/lookup-filter-input/lookup-filter-input.component';
import { FileUtilityService } from './services/file-utility.service';
import { KittingDetailTableWidgetComponent } from './components/widget/kitting-detail-table-widget/kitting-detail-table-widget.component';
import { PackPrimaryAccordianComponent } from '../features/setup/customer/pack/pack-primary-accordian/pack-primary-accordian.component';
import { PackSecondaryAccordianComponent } from '../features/setup/customer/pack/pack-secondary-accordian/pack-secondary-accordian.component';
import { PackOtheruomAccordianComponent } from '../features/setup/customer/pack/pack-otheruom-accordian/pack-otheruom-accordian.component';
import { PackPalletAccordianComponent } from '../features/setup/customer/pack/pack-pallet-accordian/pack-pallet-accordian.component';
// tslint:disable-next-line:max-line-length
import { CheckUpKpiMaintenancePrimarySectionComponent } from '../features/control/checkup-kpi-maintenance/checkup-kpi-maintenance-primary-section/checkup-kpi-maintenance-primary-section.component';
import { AdvanceConfigurationTableWidgetComponent } from './components/widget/advance-configuration-table-widget/advance-configuration-table-widget';
// tslint:disable-next-line:max-line-length
import { CommodityCatchWeightAccordianComponent } from '../features/setup/customer/commodity/commodity-catchWeight-accordian/commodity-catchWeight-accordian.component';
import { CommodityOthersAccordianComponent } from '../features/setup/customer/commodity/commodity-others-accordian/commodity-others-accordian.component';
import { CommodityNotesAccordianComponent } from '../features/setup/customer/commodity/commodity-notes-accordian/commodity-notes-accordian.component';
// tslint:disable-next-line:max-line-length
import { CommodityOTMAccordianComponent } from '../features/setup/customer/commodity/commodity-otmCommodity-accordian/commodity-otmCommodity-accordian.component';
import { CommoditySkuImageAccordianComponent } from '../features/setup/customer/commodity/commodity-skuImage-accordian/commodity-skuImage-accordian.component';
import { CommodityPrimaryAccordianComponent } from '../features/setup/customer/commodity/commodity-primary-accordian/commodity-primary-accordian.component';
// tslint:disable-next-line:max-line-length
import { CommoditySecondaryAccordianComponent } from '../features/setup/customer/commodity/commodity-secondary-accordian/commodity-secondary-accordian.component';
import { PopulateMultiReceiptLineItemComponent } from './lookup/populate-multireceipt-lineitem/populate-multireceipt-lineitem';
// tslint:disable-next-line:max-line-length
import { InventoryReplenishAccordianComponent } from '../features/inventory/inventory-replenish/inventory-replenish-accordian/inventory-replenish-accordian.component';
import { InventoryStaticFormComponent } from '../features/inventory/inventory-replenish/inventory-static-form-page/inventory-static-form-page.component';
import { CommodityTertiaryAccordianComponent } from '../features/setup/customer/commodity/commodity-tertiary-accordian/commodity-tertiary-accordian.component';
// tslint:disable-next-line:max-line-length
import { CommodityTaskManagementAccordianComponent } from '../features/setup/customer/commodity/commodity-taskmanagement-accordian.component.ts/commodity-taskmanagement-accordian.component';
import { CommodityWidgetLayoutComponent } from './components/layout/commodity-widget-layout/commodity-widget-layout.component';
import { CommodityAdvanceSkuWidgetComponent } from './components/widget/commodity-advance-sku-widget/commodity-advance-sku-widget';
import { CommodityGeneralAccordianComponent } from '../features/setup/customer/commodity/commodity-general-accordian/commodity-general-accordian.component';
import { CommoditySkuInfoAccordionComponent } from '../features/setup/customer/commodity/commodity-skuInfo-accordian/commodity-skuInfo-accordian.component';
import { ViewLocationLookupComponent } from '../features/setup/customer/commodity/commodity-home/popup/view-location-popup.component';
import { CommodityUOMAccordianComponent } from '../features/setup/customer/commodity/commodity-uom-accordian/commodity-uom-accordian.component';
// tslint:disable-next-line:max-line-length
import { PutAwayPrimaryAccordionComponent } from '../features/setup/customer/strategies/putaway-strategy/putaway-strategy-home/putaway-strategy-primary-accordion/putaway-primary-accordiancomponent';
import { AssignWorkstationPopupComponent } from './lookup/assign-workstation-popup/assign-workstation-popup.component';
import { TimeMaskComponent } from './components/time-mask/time-mask.component';
// tslint:disable-next-line:max-line-length
import { ViewTransactionsPopupComponent } from './components/common/view-transactions-popup/view-transactions-popup.component';
import { ViewBalancesPopupComponent } from './components/common/view-balances-popup/view-balances-popup.component';
import {UserDefinePopupComponent} from './components/common/userdefinefields-popup/user-define-popup.component';
import { ViewBalancesCellRendererComponent } from './components/common/view-balances-popup/view-balances-cell-renderer/view-balances-cell-renderer.component';
import { InvQcPopulatePopupComponent } from './lookup/inv-qc-popup/inv-qc-populate-popup.component';
import { PalletImagePopupComponent } from '../features/inventory/asrs/pallet-image-home/pallet-image-popup/pallet-image-popup.component';
import { SearchCriteriaPopupComponent } from './lookup/search-criteria-popup/search-criteria-popup.component';
import { SearchCriteriaCellRendererComponent } from './lookup/search-criteria-popup/search-criteria-cell-renderer/search-criteria-cell-renderer.component';
import { SearchCriteriaCellEditorComponent } from './lookup/search-criteria-popup/search-criteria-cell-editor/search-criteria-cell-editor.component';
// tslint:disable-next-line:max-line-length
import { JobMaintenancePrimaryAccordianComponent } from '../features/inventory/work-order-management/work-order-execution/job-maintenence/job-maintenance-primary-accordian/job-maintenance-primary-accordian.component';
import { CCSearchPopupComponent } from '../features/inventory/cycle-count/stock-take-parameters/cycle-count-home/cycle-count-details/cc-search-popup/cc-search-popup.component';
import { ShowTaskPopupComponent } from './components/common/show-task-popup/show-task-popup.component';
import { SearchFilterPopupComponent } from './lookup/search-filter-popup/search-filter-popup.component';
import { AssignPickLocationPopupComponent } from './lookup/assign-pick-location-popup/assign-pick-location-popup.component';
import { MultiColumnPopupComponent } from './lookup/multi-column-popup/multi-column-popup.component';
import { LfGaugeMeterComponent } from './components/platform/lf-gauge-meter/lf-gauge-meter.component';
// tslint:disable-next-line:max-line-length
import { AccountNumberCellRendererComponent } from '../features/inventory/pallet-management/pallet-management-inventory/account-num-cell-renderer/account-num-cell-renderer.component';
import { CheckboxComponent } from './components/checkbox/checkbox.component';
import { OrderParameterPopupComponent } from './lookup/order-parameter-popup/order-parameter-popup.component';
import { OrAndCellRendererComponent } from '../features/setup/customer/parameter-group/custom-aggrid-cells/orand-cell-renderer/orand-cell-renderer.component';
import { OrAndCellEditorComponent } from '../features/setup/customer/parameter-group/custom-aggrid-cells/orand-cell-editor/orand-cell-editor.component';
import { MultiPoPopulatePopupComponent } from './lookup/populate-multi-po-popup/multi-po-populate-popup.component';
// tslint:disable-next-line:max-line-length
import { TransferPrimaryAccordianComponent } from '../features/inventory/vas/transfer/transfer-home/transfer-primary-accordian/transfer-primary-accordian.component';
import { ShowMbolErrorLogPopupComponent } from './lookup/ship-ref-popup/show_mbol_error_popup/show-mbol-error-log-popup.component';
import { WaveShipReshipPopupComponent } from './lookup/wave-ship-reship-popup/wave-ship-reship-popup.component';
import { ReshipCellRendererComponent } from './lookup/wave-ship-reship-popup/custom-cell-renderers/reship-cell-renderer/reship-cell-renderer.component';
import { AssignLanePopupComponent } from './lookup/assign-lane-popup/assign-lane-popup.component';
import { AssignLaneCellRendererComponent } from './lookup/assign-lane-popup/assign-lane-cell-renderer/assign-lane-cell-renderer.component';
import { WaveAllocSummaryPopupComponent } from './lookup/wave-alloc-summary-popup/wave-alloc-summary-popup.component';
import { AssignLaneHeaderComponent } from './lookup/assign-lane-popup/assign-lane-custom-cell-header/assign-lane-custom-header.component';
import { AssignDriverPopupComponent } from './lookup/wave-control-popups/assign-driver-popup/assign-driver-popup.component';
import { AssignVehiclePopupComponent } from './lookup/wave-control-popups/assign-vehicle-popup/assign-vehicle-popup.component';
// tslint:disable-next-line:max-line-length
import { FullViewImgViewerPopupComponent } from '../features/setup/customer/commodity/commodity-skuImage-accordian/full-view-img-viewer/full-view-img-viewer.component';
import { MoveOrdersPopupComponent } from './lookup/wave-control-popups/move-orders-popup/move-orders-popup.component';
import { WaveFinalizeSummaryPopupComponent } from './lookup/wave-control-popups/wave-finalize-summary-popup/wave-finalize-summary-popup.component';
import { ViewBomPopupComponent } from './components/common/view-bom-popup/view-bom-popup.component';
import { PickManagementPopupComponent } from './lookup/wave-control-popups/pick-management-popup/pick-management-popup.component';
import { AsnSkuImageAccContentComponent } from '../features/inbound/asn/asn-home/asn-details/asn-sku-image-acc-content/asn-sku-image-acc-content.component';
// tslint:disable-next-line:max-line-length
import { ReportsConfigurationAccordionComponent } from '../features/reports/reports-configuration/reports-configuration-home/reports-configuration-accordion/reports-configuration-accordion.component';
import { SCEUILibraryModule } from 'sce-ui-lib';
// tslint:disable-next-line:max-line-length
import { InvAdjustmentPrimaryAccordianComponent } from '../features/inventory/inventory-adjustment/inv-adjustment-home/inv-adjustment-primary-accordian/inv-adjustment-primary-accordian.component';
import { PopulateFromLoadOrOrdersPopupComponent } from './lookup/populate-from-load-or-orders-popup/populate-from-load-or-orders-popup.component';
import { JreportLookupComponent } from './lookup/jreport-lookup/jreport-lookup.component';
import { JReportPrinterService } from './services/jreport-printer.service';
import { GenInterRecPopupComponent } from './lookup/gen-interface-rec-popup/gen-inter-rec-popup.component';
// tslint:disable-next-line:max-line-length
import { DocumentInfoPrimarySectionComponent } from '../features/control/transaction/documentinfo/documentinfo-primary-section/documentinfo-primary-section.component';
import { ExcludeFromZonePopupHelperService } from './lookup/exclude-from-zone-popup/exclude-from-zone-popup-helper.service';
// tslint:disable-next-line: max-line-length
import { ChannelTransferPrimaryAccordianComponent } from '../features/inventory/channel-inventory-management/channel-transfer/channel-transfer-home/channel-transfer-primary-accordian/channel-transfer-primary-accordian.component';
import { SqlPreviewPopupComponent } from './lookup/sql-preview-popup/sql-preview-popup.component';
import { ChannelInvHoldImportPopupComponent } from './lookup/channel-inv-hold-import-popup/channel-inv-hold-import-popup.component';
import { ComputedUOMPopupComponent } from './lookup/computed-uom-popup/computed-uom-popup.component';
import { JReportPrintComponent } from './jreport/jreport-print/jreport-print.component';
import { DoorBlockingPopupComponent } from './lookup/dock-door-booking-popups/door-blocking-popup/door-blocking-popup.component';
import { DoorSchedulePopupComponent } from './lookup/dock-door-booking-popups/door-schedule-popup/door-schedule-popup.component';
import { DockDoorBookingPrimaryAccordianComponent } from '../features/outbound/dock-door-booking/dock-door-booking-home/dock-door-booking-primary-accordian/dock-door-booking-primary-accordian.component';
import { DoorAddBookingDetailPopupComponent } from './lookup/dock-door-booking-popups/door-add-booking-detail-popup/door-add-booking-detail-popup.component';
import { GenerateBookingPopupComponent } from './lookup/dock-door-booking-popups/generate-booking-popup/generate-booking-popup.component';
import { ShipRefStatusTrackingWidgetComponent } from './components/widget/ship-ref-status-tracking-widget/ship-ref-status-tracking-widget';
import { AsnStatusTrackingWidgetComponent } from './components/widget/asn-status-tracking-widget/asn-status-tracking-widget';
import { PickManagementSearchComponent } from '../features/outbound/pick-management/pick-management-home/pick-management-search/pick-management-search.component';
import { HelpPopupComponent } from '../layout/home/help-popup/help-popup.component';
import { NgFlutterComponent } from './flutter/flutter-wrapper.component';
import { FeedbackEventService } from '../core/feedback-event.service';
import { SusFeedbackComponent } from '../layout/home/sus-feedback/sus-feedback.component';
import { FlutterNotificationService } from './flutter/flutter-notification.service';
import { PopulateMbolPopupComponent } from './lookup/populate-mbol-popup/populate-mbol-popup.component';
import { MbolErrorLogPopupComponent } from './lookup/mbol-error-log-popup/mbol-error-log-popup.component';
import { CustomCellRendererComponent } from './components/custom-cell-renderer/custom-cell-renderer.component';
import { ShortenPipe } from './pipes/shorten.pipe';
import { PopulateMultiStorerPopupComponent } from './lookup/populate-multi-storer-popup/populate-multi-storer-popup.component';
import { StatusLogsPopupComponent } from './components/common/status-logs-popup/status-logs-popup.component';
import { SanitizePasteDirective } from './directives/sanitize-paste.directive';
import { SerialNumberPopupComponent } from './lookup/serial-number-popup/serial-number-popup.component';
import { DetailedEntityBackendService } from './services/searchable-entity/detailed-entity/detailed-entity-backend.service';
import { SerialNumberPopupBackendService } from './lookup/serial-number-popup/services/serial-number-popup-backend.service';
import { SerialNumberPopupActionService } from './lookup/serial-number-popup/services/serial-number-popup-action.service';
import { WaveControlLanePopupComponent } from './lookup/wave-control-lane-popup/wave-control-lane-popup.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    HttpModule,
    CalendarModule,
    DataTableModule,
    DialogModule,
    TabViewModule,
    SliderModule,
    InputMaskModule,
    TooltipModule,
    RouterModule,
    DropdownModule,
    AgGridModule.withComponents([
      BasicCellHeaderComponent,
      BasicCellRendererComponent,
      BasicCellEditorComponent,
      PinnedCellRendererComponent
    ]),
    SCECoreModule,
    SCEUILibraryModule,
  ],
  declarations: [
    TitleCasePipe,
    ShortenPipe,
    SearchFilterComponent,
    SearchCriteriaPopupComponent,
    AssignPickLocationPopupComponent,
    ResultDataTableComponent,
    ResultDataMapperComponent,
    SearchFilterClauseComponent,
    SearchFilterConditionComponent,
    LookupPopupComponent,
    InvLookupComponent,
    ButtonPanelComponent,
    TrackScrollDirective,
    ResetScrollDirective,
    ClickOutsideDirective,
    ScrollBottomDirective,
    TemplateRefDirective,
    DropdownComponent,
    TimeMaskComponent,
    GridDatepickerComponent,
    PaginatorComponent,
    FocusDirective,
    SanitizePasteDirective,
    SearchableEntitySearchComponent,
    SearchableEntityDetailsComponent,
    InventoryBalanceSearchableEntitySearchComponent,
    /*    SearchableEntityMultiTabDetailsComponent, */
    PopulatePopupComponent,
    InvQcPopulatePopupComponent,
    ViewbalanceLookupComponent,
    AccordionComponent,
    PrintLookupComponent,
    ButtonPanelHeaderComponent,
    ManageSavedSearchComponent,
    TooltipComponent,
    AccordionLayoutComponent,
    LfTabbedpanesComponent,
    LfTabbedpaneComponent,
    BasicCellRendererComponent,
    BasicCellEditorComponent,
    BasicCellHeaderComponent,
    PinnedCellRendererComponent,
    OverflowTooltipDirective,
    TableCustomizerComponent,
    ViewLottablesLookupComponent,
    ImportComponent,
    ImportLookupComponent,
    SearchableEntityDynamicDetailsComponent,
    DefaultAccordionLayoutComponent,
    MultitabSearchableEntitySearchComponent,
    ColumnLayoutPrimaryWidgetComponent,
    ColumnLayoutSecWidgetComponent,
    DynamicWidgetHolderComponent,
    AbstractFormWidgetComponent,
    WOPacketCellRendererComponent,
    WORPacketCellRendererComponent,
    MultiTabbedDetailTableComponent,
    ShowEmptyLocationLookupComponent,
    WorkOrdersPrimaryAccordianComponent,
    SimpleWidgetLayoutComponent,
    StorerSODefaultWidgetComponent,
    StorerAdditionalInfoWidgetComponent,
    SimpleWidgetLayoutComponent, CommodityWidgetLayoutComponent,
    SearchableEntityStaticFormComponent,
    DirectMovesAccordianComponent,
    LookupInputComponent,
    ViewLocationLookupComponent,
    LookupFilterInputComponent,
    KittingDetailTableWidgetComponent,
    AdvanceConfigurationTableWidgetComponent,
    LookupFilterInputComponent,
    PackPrimaryAccordianComponent,
    PackSecondaryAccordianComponent,
    PackOtheruomAccordianComponent,
    PackPalletAccordianComponent,
    CheckUpKpiMaintenancePrimarySectionComponent,
    DocumentInfoPrimarySectionComponent,
    CommodityPrimaryAccordianComponent,
    CommoditySecondaryAccordianComponent,
    CommodityTaskManagementAccordianComponent,
    CommodityTertiaryAccordianComponent,
    CommoditySkuImageAccordianComponent,
    CommodityOTMAccordianComponent,
    CommodityNotesAccordianComponent,
    CommodityOthersAccordianComponent,
    CommodityCatchWeightAccordianComponent,
    CommodityAdvanceSkuWidgetComponent,
    CommodityGeneralAccordianComponent,
    CommoditySkuInfoAccordionComponent,
    PopulateMultiReceiptLineItemComponent,
    InventoryReplenishAccordianComponent,
    InventoryStaticFormComponent,
    CommodityUOMAccordianComponent,
    PutAwayPrimaryAccordionComponent,
    AssignWorkstationPopupComponent,
    ViewTransactionsPopupComponent,
    StatusLogsPopupComponent,
    MultiColumnPopupComponent,
    ShowTaskPopupComponent,
    ViewBalancesPopupComponent,
    UserDefinePopupComponent,
    ViewBalancesCellRendererComponent,
    PalletImagePopupComponent,
    SearchCriteriaCellRendererComponent,
    SearchCriteriaCellEditorComponent,
    JobMaintenancePrimaryAccordianComponent,
    CCSearchPopupComponent,
    SearchFilterPopupComponent,
    LfGaugeMeterComponent,
    AccountNumberCellRendererComponent,
    CheckboxComponent,
    OrderParameterPopupComponent,
    OrAndCellEditorComponent,
    OrAndCellRendererComponent,
    MultiPoPopulatePopupComponent,
    TransferPrimaryAccordianComponent,
    ShowMbolErrorLogPopupComponent,
    MbolErrorLogPopupComponent,
    WaveShipReshipPopupComponent,
    ReshipCellRendererComponent,
    AssignLanePopupComponent,
    AssignLaneCellRendererComponent,
    WaveAllocSummaryPopupComponent,
    AssignLaneHeaderComponent,
    AssignDriverPopupComponent,
    AssignVehiclePopupComponent,
    FullViewImgViewerPopupComponent,
    MoveOrdersPopupComponent,
    WaveFinalizeSummaryPopupComponent,
    PickManagementPopupComponent,
    ViewBomPopupComponent,
    AsnSkuImageAccContentComponent,
    ReportsConfigurationAccordionComponent,
    InvAdjustmentPrimaryAccordianComponent,
    PopulateFromLoadOrOrdersPopupComponent,
    GenInterRecPopupComponent,
    JreportLookupComponent,
    ChannelTransferPrimaryAccordianComponent,
    SqlPreviewPopupComponent,
    ChannelInvHoldImportPopupComponent,
    ComputedUOMPopupComponent,
    JreportLookupComponent,
    JReportPrintComponent,
    DoorBlockingPopupComponent,
    DoorSchedulePopupComponent,
    DockDoorBookingPrimaryAccordianComponent,
    DoorAddBookingDetailPopupComponent,
    GenerateBookingPopupComponent,
    ShipRefStatusTrackingWidgetComponent,
    AsnStatusTrackingWidgetComponent,
    PickManagementSearchComponent,
    HelpPopupComponent,
    NgFlutterComponent, 
    SusFeedbackComponent,
    PopulateMbolPopupComponent,
    CustomCellRendererComponent,
    PopulateMultiStorerPopupComponent,
    SerialNumberPopupComponent,
    WaveControlLanePopupComponent
  ],
  exports: [
    TitleCasePipe,
    ShortenPipe,
    SearchFilterComponent,
    SearchFilterClauseComponent,
    SearchFilterConditionComponent,
    ResultDataTableComponent,
    ResultDataMapperComponent,
    LookupPopupComponent,
    ViewLocationLookupComponent,
    InvLookupComponent,
    ButtonPanelComponent,
    TrackScrollDirective,
    ResetScrollDirective,
    ClickOutsideDirective,
    ScrollBottomDirective,
    DropdownComponent,
    TimeMaskComponent,
    GridDatepickerComponent,
    PaginatorComponent,
    FocusDirective,
    SanitizePasteDirective,
    SearchableEntitySearchComponent,
    SearchableEntityDetailsComponent,
    InventoryBalanceSearchableEntitySearchComponent,
    AccordionComponent,
    AccordionLayoutComponent,
    LfTabbedpanesComponent,
    LfTabbedpaneComponent,
    TooltipComponent,
    OverflowTooltipDirective,
    TableCustomizerComponent,
    ImportComponent,
    ImportLookupComponent,
    SearchableEntityDynamicDetailsComponent,
    DefaultAccordionLayoutComponent,
    MultitabSearchableEntitySearchComponent,
    ColumnLayoutPrimaryWidgetComponent,
    ColumnLayoutSecWidgetComponent,
    DynamicWidgetHolderComponent,
    MultiTabbedDetailTableComponent,
    ShowEmptyLocationLookupComponent,
    WorkOrdersPrimaryAccordianComponent,
    SimpleWidgetLayoutComponent,
    StorerSODefaultWidgetComponent,
    StorerAdditionalInfoWidgetComponent,
    SimpleWidgetLayoutComponent, CommodityWidgetLayoutComponent,
    SearchableEntityStaticFormComponent,
    DirectMovesAccordianComponent,
    LookupInputComponent,
    LookupFilterInputComponent,
    KittingDetailTableWidgetComponent,
    AdvanceConfigurationTableWidgetComponent,
    PackPrimaryAccordianComponent,
    PackSecondaryAccordianComponent,
    PackOtheruomAccordianComponent,
    PackPalletAccordianComponent,
    CheckUpKpiMaintenancePrimarySectionComponent,
    DocumentInfoPrimarySectionComponent,
    CommodityPrimaryAccordianComponent,
    CommoditySecondaryAccordianComponent,
    CommodityTaskManagementAccordianComponent,
    CommodityTertiaryAccordianComponent,
    CommoditySkuImageAccordianComponent,
    CommodityOTMAccordianComponent,
    CommodityNotesAccordianComponent,
    CommodityOthersAccordianComponent,
    CommodityCatchWeightAccordianComponent,
    CommodityAdvanceSkuWidgetComponent,
    CommodityGeneralAccordianComponent,
    CommoditySkuInfoAccordionComponent,
    PopulateMultiReceiptLineItemComponent,
    InventoryReplenishAccordianComponent,
    InventoryStaticFormComponent,
    CommodityUOMAccordianComponent,
    PutAwayPrimaryAccordionComponent,
    ViewTransactionsPopupComponent,
    StatusLogsPopupComponent,
    MultiColumnPopupComponent,
    ShowTaskPopupComponent,
    ViewBalancesPopupComponent,
    UserDefinePopupComponent,
    ViewBalancesCellRendererComponent,
    PalletImagePopupComponent,
    JobMaintenancePrimaryAccordianComponent,
    CCSearchPopupComponent,
    SearchFilterPopupComponent,
    LfGaugeMeterComponent,
    AccountNumberCellRendererComponent,
    CheckboxComponent,
    OrderParameterPopupComponent,
    OrAndCellEditorComponent,
    OrAndCellRendererComponent,
    MultiPoPopulatePopupComponent,
    TransferPrimaryAccordianComponent,
    ShowMbolErrorLogPopupComponent,
    MbolErrorLogPopupComponent,
    WaveShipReshipPopupComponent,
    WaveAllocSummaryPopupComponent,
    AssignDriverPopupComponent,
    AssignVehiclePopupComponent,
    FullViewImgViewerPopupComponent,
    MoveOrdersPopupComponent,
    WaveFinalizeSummaryPopupComponent,
    PickManagementPopupComponent,
    ViewBomPopupComponent,
    ReportsConfigurationAccordionComponent,
    InvAdjustmentPrimaryAccordianComponent,
    PopulateFromLoadOrOrdersPopupComponent,
    GenInterRecPopupComponent,
    JreportLookupComponent,
    ChannelTransferPrimaryAccordianComponent,
    ChannelInvHoldImportPopupComponent,
    ComputedUOMPopupComponent,
    JReportPrintComponent,
    DockDoorBookingPrimaryAccordianComponent,
    ShipRefStatusTrackingWidgetComponent,
    AsnStatusTrackingWidgetComponent,
    PickManagementSearchComponent,
    HelpPopupComponent,
    NgFlutterComponent,
    SusFeedbackComponent,
    PopulateMbolPopupComponent,
    CustomCellRendererComponent,
    PopulateMultiStorerPopupComponent,
    SerialNumberPopupComponent,
    WaveControlLanePopupComponent
  ],
  entryComponents: [
    SearchCriteriaPopupComponent,
    AssignPickLocationPopupComponent,
    LookupPopupComponent,
    ViewLocationLookupComponent,
    InvLookupComponent,
    PopulatePopupComponent,
    InvQcPopulatePopupComponent,
    ViewbalanceLookupComponent,
    PrintLookupComponent,
    ViewLottablesLookupComponent,
    ImportLookupComponent,
    ImportLookupComponent,
    ColumnLayoutPrimaryWidgetComponent,
    ColumnLayoutSecWidgetComponent,
    WOPacketCellRendererComponent,
    WORPacketCellRendererComponent,
    MultiTabbedDetailTableComponent,
    ShowEmptyLocationLookupComponent,
    WorkOrdersPrimaryAccordianComponent,
    StorerSODefaultWidgetComponent,
    StorerAdditionalInfoWidgetComponent,
    WorkOrdersPrimaryAccordianComponent,
    DirectMovesAccordianComponent,
    KittingDetailTableWidgetComponent,
    AdvanceConfigurationTableWidgetComponent,
    PackPrimaryAccordianComponent,
    PackSecondaryAccordianComponent,
    PackOtheruomAccordianComponent,
    PackPalletAccordianComponent,
    CheckUpKpiMaintenancePrimarySectionComponent,
    DocumentInfoPrimarySectionComponent,
    CommodityPrimaryAccordianComponent,
    CommoditySecondaryAccordianComponent,
    CommodityTaskManagementAccordianComponent,
    CommodityTertiaryAccordianComponent,
    CommoditySkuImageAccordianComponent,
    CommodityOTMAccordianComponent,
    CommodityNotesAccordianComponent,
    CommodityOthersAccordianComponent,
    CommodityCatchWeightAccordianComponent,
    CommodityAdvanceSkuWidgetComponent,
    CommodityGeneralAccordianComponent,
    CommoditySkuInfoAccordionComponent,
    PopulateMultiReceiptLineItemComponent,
    InventoryReplenishAccordianComponent,
    InventoryStaticFormComponent,
    CommodityUOMAccordianComponent,
    PutAwayPrimaryAccordionComponent,
    AssignWorkstationPopupComponent,
    ViewTransactionsPopupComponent,
    StatusLogsPopupComponent,
    MultiColumnPopupComponent,
    ShowTaskPopupComponent,
    ViewBalancesPopupComponent,
    UserDefinePopupComponent,
    ViewBalancesCellRendererComponent,
    PalletImagePopupComponent,
    SearchCriteriaCellRendererComponent,
    SearchCriteriaCellEditorComponent,
    JobMaintenancePrimaryAccordianComponent,
    CCSearchPopupComponent,
    SearchFilterPopupComponent,
    AccountNumberCellRendererComponent,
    OrderParameterPopupComponent,
    OrAndCellEditorComponent,
    OrAndCellRendererComponent,
    MultiPoPopulatePopupComponent,
    TransferPrimaryAccordianComponent,
    ShowMbolErrorLogPopupComponent,
    MbolErrorLogPopupComponent,
    WaveShipReshipPopupComponent,
    ReshipCellRendererComponent,
    AssignLanePopupComponent,
    AssignLaneCellRendererComponent,
    WaveAllocSummaryPopupComponent,
    AssignLaneHeaderComponent,
    AssignDriverPopupComponent,
    AssignVehiclePopupComponent,
    FullViewImgViewerPopupComponent,
    MoveOrdersPopupComponent,
    WaveFinalizeSummaryPopupComponent,
    PickManagementPopupComponent,
    ViewBomPopupComponent,
    ReportsConfigurationAccordionComponent,
    InvAdjustmentPrimaryAccordianComponent,
    PopulateFromLoadOrOrdersPopupComponent,
    GenInterRecPopupComponent,
    JreportLookupComponent,
    JReportPrintComponent,
    ChannelTransferPrimaryAccordianComponent,
    SqlPreviewPopupComponent,
    ChannelInvHoldImportPopupComponent,
    ComputedUOMPopupComponent,
    DoorBlockingPopupComponent,
    DoorSchedulePopupComponent,
    DockDoorBookingPrimaryAccordianComponent,
    DoorAddBookingDetailPopupComponent,
    GenerateBookingPopupComponent,
    ShipRefStatusTrackingWidgetComponent,
    AsnStatusTrackingWidgetComponent,
    HelpPopupComponent,
    SusFeedbackComponent,
    PopulateMbolPopupComponent,
    CustomCellRendererComponent,
    PopulateMultiStorerPopupComponent,
    SerialNumberPopupComponent,
    WaveControlLanePopupComponent
  ],
  providers: [
    DocumentUtilService,
    ReceiptDataService,
    DetailedEntityBackendService,
    ReceiptDataEditorService,
    ViewbalanceService,
    SearchService,
    LocalPagedSearchService,
    SearchParams,
    SearchStatus,
    PrinterService,
    JReportPrinterService,
    PrinterSetupService,
  //  CustomPaginationService,
    ValidatorService,
    SharedServiceRegistry,
    ViewLottableService,
    CrossFunctionalityNavigationService,
    FeedbackEventService,
    ExcludeFromZonePopupHelperService,
    SerialNumberPopupBackendService,
    SerialNumberPopupActionService
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: SharedModule,
      providers: [
        ButtonFactoryService,
        DataTableEditorService,
        SavedSearchService,
        FlutterNotificationService,
     //   CustomPaginationService,
        AccordionComponent,
        ButtonPanelComponent,
        ButtonPanelHeaderComponent,
        SharedServiceRegistry,
        FileImportService,
        CrossFunctionalityNavigationService,
        LocalPagedDataManager,
        FileUtilityService,
       // ModalService,
       // DatePickerConfigService
      ]
    };
  }
}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/shared.module.ts